"use client";

import { cn } from "@/lib/utils";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
}

/**
 * Theme-aware loading indicator: concentric arcs orbiting a pulsing core,
 * drawn entirely from the active theme's primary/secondary tokens so it
 * recolors with the selected theme (no baked-in brand asset).
 */
export default function LoadingScreen({ className, title }: Props) {
  return (
    <div
      className={cn(
        "absolute left-0 top-0 flex size-full flex-col items-center justify-center gap-6 align-middle",
        className,
      )}
    >
      <div className="relative size-24" role="status" aria-label="Loading">
        <div className="absolute inset-0 animate-[ai-orbit_2.4s_linear_infinite] rounded-full border-2 border-transparent border-r-secondary/30 border-t-secondary motion-reduce:animate-none" />
        <div className="absolute inset-3 animate-[ai-orbit-reverse_1.7s_linear_infinite] rounded-full border-2 border-transparent border-b-primary border-l-primary/40 motion-reduce:animate-none" />
        <div className="absolute inset-7 animate-[ai-core_1.6s_ease-in-out_infinite] rounded-full bg-[radial-gradient(circle,_hsl(var(--secondary)/0.35),_transparent_70%)] motion-reduce:animate-none" />
        <div className="absolute inset-0 m-auto size-2.5 animate-[ai-core_1.6s_ease-in-out_infinite] rounded-full bg-secondary motion-reduce:animate-none" />
      </div>
      {title && <h3>{title}</h3>}
    </div>
  );
}
